<div id="loading-check">
  <div class="wrap-item" *ngIf="!checkPermissionService.isNoPermission">
    <mat-progress-spinner role="progressbar" aria-label="Progress Spinner" diameter="50" mode="indeterminate">
    </mat-progress-spinner>
    <p>Loading...</p>
  </div>
</div>
